var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"Rate Type Details","backBtn":true,"showLoading":_vm.isLoading}}),_c('v-container',{staticClass:"lighten-12",attrs:{"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }